import React, { forwardRef } from "react";
import { __ } from "@wordpress/i18n";
const UnforwardedUpdates = (props, ref) => {
	return (
		<div
			ref={ref}
			style={{ minHeight: "50vh" }}
			className="image-hub-settings-updates-container"
		>
			<h1>{__("Updates & Changelog","image-hub")}</h1>
			<h4>
				{__(
					"Stay up to date with the latest improvements, fixes, and new features.","image-hub"
				)}
			</h4>
		</div>
	);
};

export const Updates = forwardRef(UnforwardedUpdates);
